<a style="color: #fff" (click)="download()" *ngIf="!loading"
   class="d-flex tw-px-4 tw-justify-center tw-text-white tw-py-1.5 tw-rounded tw-text-center tw-text-sm tw-items-center tw-bg-purple-500 tw-gap-2 tw-flex"><i
   class="fa fa-download"></i>Shipping
   Label
</a>
<a style="color: #fff" *ngIf="loading"
   class="d-flex tw-px-4 tw-justify-center tw-text-white tw-py-1.5 tw-rounded tw-text-center tw-text-sm tw-items-center tw-bg-purple-500 tw-gap-2 tw-flex">
   <i class="fa fa-spinner tw-animate-spin"></i>
</a>
